var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M673.482 114.327C720.241 151.654 757.98 199.047 783.888 252.978L425.263 425.264L673.482 114.327Z",
    fill: "url(#paint0_linear_90_23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M514.087 37.4436C572.326 50.7821 626.813 77.0659 673.504 114.344L425.264 425.264L514.087 37.4436Z",
    fill: "url(#paint1_linear_90_23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M672.397 737.066C625.573 774.178 570.993 800.268 512.707 813.399L425.265 425.264L672.397 737.066Z",
    fill: "url(#paint2_linear_90_23)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M783.163 599.051C757.066 652.797 719.199 699.975 672.373 737.083L425.263 425.264L783.163 599.051Z",
    fill: "url(#paint3_linear_90_23)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M823.126 426.653C822.917 486.399 809.255 545.332 783.154 599.076L425.266 425.264L823.126 426.653Z",
    fill: "url(#paint4_linear_90_23)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M784.07 253.353C809.922 307.311 823.272 366.405 823.126 426.236L425.264 425.264L784.07 253.353Z",
    fill: "url(#paint5_linear_90_23)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512.732 813.393C454.447 826.528 393.952 826.367 335.737 812.923L425.264 425.264L512.732 813.393Z",
    fill: "url(#paint6_linear_90_23)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4589 597.175C40.6431 543.293 27.294 484.289 27.4024 424.542L425.264 425.264L66.4589 597.175Z",
    fill: "url(#paint7_linear_90_23)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.504 735.768C129.876 698.412 92.2593 651.034 66.4472 597.15L425.264 425.264L176.504 735.768Z",
    fill: "url(#paint8_linear_90_23)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.766 812.929C277.55 799.489 223.109 773.11 176.483 735.751L425.265 425.264L335.766 812.929Z",
    fill: "url(#paint9_linear_90_23)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M337.119 37.2894C395.381 24.0526 455.877 24.1075 514.115 37.4501L425.265 425.265L337.119 37.2894Z",
    fill: "url(#paint10_linear_90_23)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.59 113.894C224.348 76.7006 278.883 50.5157 337.146 37.2829L425.265 425.264L177.59 113.894Z",
    fill: "url(#paint11_linear_90_23)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0614 252.103C93.0651 198.311 130.85 151.067 177.611 113.877L425.264 425.265L67.0614 252.103Z",
    fill: "url(#paint12_linear_90_23)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4013 424.57C27.5056 364.823 41.0647 305.867 67.0722 252.078L425.263 425.265L27.4013 424.57Z",
    fill: "url(#paint13_linear_90_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_23",
    x1: 553.247,
    y1: 212.38,
    x2: 715.628,
    y2: 373.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_23",
    x1: 448.268,
    y1: 177.938,
    x2: 664.294,
    y2: 252.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_23",
    x1: 643.21,
    y1: 626.846,
    x2: 376.276,
    y2: 681.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_23",
    x1: 661.075,
    y1: 503.315,
    x2: 539.963,
    y2: 697.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_23",
    x1: 676.446,
    y1: 417.237,
    x2: 602.203,
    y2: 635.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_23",
    x1: 647.913,
    y1: 308.715,
    x2: 675.915,
    y2: 537.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_23",
    x1: 489.164,
    y1: 668.312,
    x2: 260.173,
    y2: 644.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_23",
    x1: 217.385,
    y1: 561.225,
    x2: 141.151,
    y2: 345.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_23",
    x1: 275.183,
    y1: 626.837,
    x2: 150.857,
    y2: 433.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_90_23",
    x1: 401.83,
    y1: 672.55,
    x2: 185.934,
    y2: 597.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_90_23",
    x1: 338.738,
    y1: 192.429,
    x2: 565.669,
    y2: 165.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_90_23",
    x1: 255.307,
    y1: 251.04,
    x2: 478.44,
    y2: 155.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_90_23",
    x1: 131.776,
    y1: 376.578,
    x2: 360.276,
    y2: 159.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_90_23",
    x1: 174.098,
    y1: 433.73,
    x2: 247.96,
    y2: 215.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors14);
export default __webpack_public_path__ + "static/media/sectors-14.68154cf195615f3284b704a4cae018b5.svg";
export { ForwardRef as ReactComponent };